import { Vue, Options } from 'vue-class-component';
import CommandIconComponent from '@/views/components/CommandIcon/CommandIconComponent.vue';
import { DefaultDevicesSettingsDTO } from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';

@Options({
  name: 'DialogCommandIcon',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    defaultSettings: {
      type: Object as PropType<DefaultDevicesSettingsDTO>,
      required: true,
    },
  },
  watch: {
    isVisible(newValue) {
      this.isDialogVisible = newValue;
    },
  },
  emits: ['hide-dialog', 'confirm'],
  components: {
    CommandIconComponent,
  },
})
export default class DialogCommandIcon extends Vue {
  isVisible!: boolean;
  isDialogVisible = false;

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  doConfirm() {
    this.$emit('confirm');
    this.handleHideDialog();
  }
}
